import { useGetClientsWithConfigsQuery } from "../../../features/clients/clientConfigSlice";
import { useGetLotsQuery } from "../../../features/lots/lotSlice";
import DropdownFilter from "../../DropdownFilter";
import { getLotsWithPmfText } from "../../../features/lots/lotUtil";

export default function LotsDropdown({
    title,
    identifier,
    onSelect,
    showEmpty,
    clientAccountId,
    value,
    multiple,
    pmfLot,
    required,
    classStyles,
    newLots=[]
}) {
    let { data: clientsWithConfigs, error: error, isLoading: isLoading } = useGetClientsWithConfigsQuery(null);
    let { data: getLots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    const clientsConfigs = clientsWithConfigs?.find(c => c.clientAccountId == clientAccountId);
    let lots = clientsConfigs?.clientLots.length > 0 ? getLots?.filter(lot => clientsConfigs?.clientLots?.find(l => l.lotId == lot.id)) : getLots;
    lots = pmfLot ? lots?.filter(lot => lot.pmfLot) : lots; 
    lots = (lots && newLots) ? [...lots, ...newLots] : lots;

    return (
        <DropdownFilter
            title={title}
            identifier={identifier}
            values={getLotsWithPmfText(lots) ?? []}
            onSelect={onSelect}
            value={value}
            showEmpty={showEmpty}
            multiple={multiple}
            required={required}
            classStyles={classStyles} />
    )
}